import { NifOrderRowFragment, NifOrderStatus } from '@src/generated/graphql';
import { NifOrderStatusInfo } from './types';

const NIF_ORDER_STATUS_MAP: Record<
  NifOrderStatus,
  NifOrderStatusInfo | ((order: NifOrderRowFragment) => NifOrderStatusInfo)
> = {
  DRAFT: {
    state: 'DRAFT',
    message:
      // t('nif:dashboard.status_message.draft', 'Complete the form so that we can start processing your order.')
      'nif:dashboard.status_message.draft',
  },
  PAYMENT_PENDING: {
    state: 'PENDING_BORDR_ACTION',
    message:
      // t('nif:dashboard.status_message.payment_pending', 'Your payment is currently being processed.')
      'nif:dashboard.status_message.payment_pending',
  },
  AWAITING_INTAKE: {
    state: 'PENDING_CUSTOMER_ACTION',
    message:
      // t('nif:dashboard.status_message.awaiting_intake', 'Please provide updated document(s) for your application.')
      'nif:dashboard.status_message.awaiting_intake',
  },
  INTAKE_REVIEW: {
    state: 'PENDING_BORDR_ACTION',
    message:
      // t('nif:dashboard.status_message.review_by_bordr', 'Your application is being reviewed by the Bordr team. No action needed.')
      'nif:dashboard.status_message.review_by_bordr',
  },
  POA_TO_BE_SENT: {
    state: 'PENDING_BORDR_ACTION',
    message: 'nif:dashboard.status_message.review_by_bordr',
  },
  POA_PENDING: {
    state: 'PENDING_CUSTOMER_ACTION',
    message:
      // t('nif:dashboard.status_message.poa_pending', 'Please sign your Power of Attorney.')
      'nif:dashboard.status_message.poa_pending',
  },
  POA_RECEIVED: {
    state: 'PENDING_BORDR_ACTION',
    message:
      // t('nif:dashboard.status_message.poa_received', 'Your Power of Attorney has been received. No action needed.')
      'nif:dashboard.status_message.poa_received',
  },
  NIF_REQUESTED: {
    state: 'PENDING_BORDR_ACTION',
    // t('nif:dashboard.status_message.nif_requested', 'Your NIF has been requested.')
    message: 'nif:dashboard.status_message.nif_requested',
  },
  NIF_RECEIVED: (order) => {
    if (order.hasPasswordRequest) {
      return {
        state: 'COMPLETED',
        // t('nif:dashboard.status_message.password_sent', 'Your temporary password to the Portal de Financas has been sent to your email.')
        ...(order.hasCompletedPasswordRequest && {
          message: 'nif:dashboard.status_message.password_sent',
        }),
      };
    }
    return {
      state: 'COMPLETED',
    };
  },
  CANCELLED: {
    state: 'CANCELLED',
    // t('nif:dashboard.status_message.nif_cancelled', 'Your NIF order was cancelled.')
    message: 'nif:dashboard.status_message.nif_cancelled',
  },
};

export function getNifOrderStatusInfo(
  order: NifOrderRowFragment,
): NifOrderStatusInfo {
  const statusInfo = NIF_ORDER_STATUS_MAP[order.status];

  return typeof statusInfo === 'function' ? statusInfo(order) : statusInfo;
}
